/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './dynamic-checkbox.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@covalent/dynamic-forms/dynamic-elements/dynamic-checkbox/dynamic-checkbox.component';
import * as i3 from '../../../../@angular/material/typings/index.ngfactory';
import * as i4 from '@angular/forms';
import * as i5 from '@angular/material';
const styles_TdDynamicCheckboxComponent:any[] = [i0.styles];
export const RenderType_TdDynamicCheckboxComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_TdDynamicCheckboxComponent,data:{}});
export function View_TdDynamicCheckboxComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),12,'div',[['class',
      'dynamic-checkbox-wrapper']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted((null as any),['\n  '])),(_l()(),i1.ɵeld(0,(null as any),
      (null as any),9,'md-checkbox',[['class','mat-checkbox'],['flex','']],[[1,'required',
          0],[2,'mat-checkbox-indeterminate',(null as any)],[2,'mat-checkbox-checked',
          (null as any)],[2,'mat-checkbox-disabled',(null as any)],[2,'mat-checkbox-label-before',
          (null as any)],[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
          [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
              (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],
      [[(null as any),'ngModelChange']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i2.TdDynamicCheckboxComponent = _v.component;
        if (('ngModelChange' === en)) {
          const pd_0:any = ((<any>(_co.value = $event)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i3.View_MdCheckbox_0,i3.RenderType_MdCheckbox)),i1.ɵdid(16384,(null as any),
      0,i4.RequiredValidator,([] as any[]),{required:[0,'required']},(null as any)),
      i1.ɵprd(1024,(null as any),i4.NG_VALIDATORS,(p0_0:any) => {
        return [p0_0];
      },[i4.RequiredValidator]),i1.ɵdid(4374528,(null as any),0,i5.MdCheckbox,[i1.Renderer2,
          i1.ElementRef,i1.ChangeDetectorRef,i5.FocusOriginMonitor],{required:[0,'required']},
          (null as any)),i1.ɵprd(1024,(null as any),i4.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i5.MdCheckbox]),i1.ɵdid(671744,(null as any),0,i4.NgModel,[[8,(null as any)],
          [2,i4.NG_VALIDATORS],[8,(null as any)],[2,i4.NG_VALUE_ACCESSOR]],{model:[0,
          'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i4.NgControl,
          (null as any),[i4.NgModel]),i1.ɵdid(16384,(null as any),0,i4.NgControlStatus,
          [i4.NgControl],(null as any),(null as any)),i1.ɵdid(16384,(null as any),
          0,i5.MdPrefixRejector,[[2,i5.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),(_l()(),i1.ɵted(0,['\n    ','\n  '])),(_l()(),
          i1.ɵted((null as any),['\n']))],(_ck,_v) => {
    var _co:i2.TdDynamicCheckboxComponent = _v.component;
    const currVal_12:any = _co.required;
    _ck(_v,3,0,currVal_12);
    const currVal_13:any = _co.required;
    _ck(_v,5,0,currVal_13);
    const currVal_14:any = _co.value;
    _ck(_v,7,0,currVal_14);
  },(_ck,_v) => {
    var _co:i2.TdDynamicCheckboxComponent = _v.component;
    const currVal_0:any = (i1.ɵnov(_v,3).required? '': (null as any));
    const currVal_1:any = i1.ɵnov(_v,5).indeterminate;
    const currVal_2:any = i1.ɵnov(_v,5).checked;
    const currVal_3:any = i1.ɵnov(_v,5).disabled;
    const currVal_4:any = (i1.ɵnov(_v,5).labelPosition == 'before');
    const currVal_5:any = i1.ɵnov(_v,9).ngClassUntouched;
    const currVal_6:any = i1.ɵnov(_v,9).ngClassTouched;
    const currVal_7:any = i1.ɵnov(_v,9).ngClassPristine;
    const currVal_8:any = i1.ɵnov(_v,9).ngClassDirty;
    const currVal_9:any = i1.ɵnov(_v,9).ngClassValid;
    const currVal_10:any = i1.ɵnov(_v,9).ngClassInvalid;
    const currVal_11:any = i1.ɵnov(_v,9).ngClassPending;
    _ck(_v,2,1,[currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7,currVal_8,currVal_9,currVal_10,currVal_11]);
    const currVal_15:any = _co.label;
    _ck(_v,11,0,currVal_15);
  });
}
export function View_TdDynamicCheckboxComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'td-dynamic-checkbox',
      ([] as any[]),(null as any),(null as any),(null as any),View_TdDynamicCheckboxComponent_0,
      RenderType_TdDynamicCheckboxComponent)),i1.ɵprd(5120,(null as any),i4.NG_VALUE_ACCESSOR,
      (p0_0:any) => {
        return [p0_0];
      },[i2.TdDynamicCheckboxComponent]),i1.ɵdid(49152,(null as any),0,i2.TdDynamicCheckboxComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const TdDynamicCheckboxComponentNgFactory:i1.ComponentFactory<i2.TdDynamicCheckboxComponent> = i1.ɵccf('td-dynamic-checkbox',
    i2.TdDynamicCheckboxComponent,View_TdDynamicCheckboxComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/$$_gendir/~/@covalent/dynamic-forms/dynamic-elements/dynamic-checkbox/dynamic-checkbox.component.ngfactory.ts